/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiNoteFromJSON, StreemApiNoteToJSON, } from './';
export function StreemApiUpdateRoomNoteResponseFromJSON(json) {
    return StreemApiUpdateRoomNoteResponseFromJSONTyped(json, false);
}
export function StreemApiUpdateRoomNoteResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'note': !exists(json, 'note') ? undefined : StreemApiNoteFromJSON(json['note']),
    };
}
export function StreemApiUpdateRoomNoteResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'note': StreemApiNoteToJSON(value.note),
    };
}
//# sourceMappingURL=StreemApiUpdateRoomNoteResponse.js.map